<!--
  * @Description: 
  * @Author: 
  * @Date: 2022-08-24 10:16:23
 * @LastEditTime: 2026-01-15 16:52:02
 * @LastEditors: dongqianqian
  * @Usage: 
 -->
 <template>
  <div class="map-warp">
    <baidu-map
      class="map"
      :ak="bdAk"
      :zoom="zoom"
      @ready="handler"
      :dragging="true"
      :scroll-wheel-zoom="true"
      @zoomend="syncCenterAndZoom"
    >
      <!-- <bm-marker
        :position="center"
        :dragging="true"
      >
        <bm-label
          content=""
          :offset="{width: -35, height: 30}"
        />
      </bm-marker> -->
    </baidu-map>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map'
// import BmMarker from "vue-baidu-map/components/overlays/Marker";
// import BaiduMapAll from 'vue-baidu-map'

export default {
  name: "BaiDuMap",
  components: {
    BaiduMap,
    // BmMarker
  },
  data() {
    return {
      center: '', // 地址字符串
      zoom: 16, // 地图展示级别（与切换地址后的缩放级别一致）
      BMap: null, // BMap类
      bdAk: "",
      map: null, // 地图对象
      pendingCenter: '' // 地图未就绪时暂存的地址
    }
  },
  props: {
    selectAddress: {
      type: String,
      default: '',
    },
    companyInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    // 判断地图是否就绪
    isMapReady() {
      return this.map && this.BMap
    }
  },
  watch: {
    // 地址变更时重新定位（优先使用地址解析，不使用旧坐标）
    selectAddress(newVal) {
      if (!newVal) {
        // 地址为空时，清除标记点
        if (this.isMapReady) {
          this.clearMapMarkers(this.map)
        }
        return
      }
      this.center = newVal
      this.updateMapLocation(true) // true 表示是地址变更，优先使用地址解析
    },
    // 项目信息变更时更新地图
    companyInfo: {
      handler(newVal) {
        if (!newVal) return
        this.updateMapLocation(false) // false 表示可以使用坐标点
      },
      deep: true,
      immediate: false
    }
  },
  mounted() {
    this.initCenter();
    this.bdAk = window.getStore({ name: "baiduMapAK" });
  },
  methods: {
    // 初始化地址中心点
    initCenter() {
      // 优先使用 selectAddress（父组件构建好的完整地址）
      if (this.selectAddress) {
        this.center = this.selectAddress
        return
      }
      // 从 companyInfo 构建地址
      if (!this.companyInfo || !this.companyInfo.provinceName) {
        return
      }
      const { provinceName, cityName, areaName, address } = this.companyInfo
      // 直辖市：省+区+详细地址；其他省份：省+市+区+详细地址
      if (provinceName === cityName) {
        this.center = provinceName + (areaName || '') + (address || '')
      } else {
        this.center = provinceName + (cityName || '') + (areaName || '') + (address || '')
      }
    },
    // 统一更新地图位置的方法
    // isAddressChange: true-地址变更（优先地址解析），false-项目信息变更（可使用坐标）
    updateMapLocation(isAddressChange = false) {
      if (!this.isMapReady) {
        // 地图未就绪，暂存地址
        this.initCenter()
        if (this.center) {
          this.pendingCenter = this.center
        }
        return
      }

      // 如果是地址变更，优先使用地址解析，不使用旧坐标
      if (isAddressChange) {
        this.initCenter()
        if (this.center) {
          this.parseAddress(this.BMap, this.map)
        } else {
          // 地址为空，清除标记点
          this.clearMapMarkers(this.map)
        }
        return
      }

      // 项目信息变更时，优先使用坐标
      if (this.companyInfo?.pointX && this.companyInfo?.pointY) {
        this.setMarkerByPoint(
          parseFloat(this.companyInfo.pointX),
          parseFloat(this.companyInfo.pointY),
          this.companyInfo.address || ''
        )
        return
      }

      // 如果没有坐标，使用地址解析
      this.initCenter()
      if (this.center) {
        this.parseAddress(this.BMap, this.map)
      }
    },
    // 根据坐标设置标记点
    setMarkerByPoint(lng, lat, title = '') {
      if (!this.isMapReady) return
      const point = new this.BMap.Point(lng, lat)
      this.map.clearOverlays()
      this.map.centerAndZoom(point, 16)
      this.map.addOverlay(new this.BMap.Marker(point, { title }))
      this.$emit('mapPoint', { lng, lat })
    },
    syncCenterAndZoom() {
      // 预留方法
    },
    // 地图初始化完成
    async handler({ BMap, map }) {
      map.clearOverlays()
      this.BMap = BMap
      this.map = map
      this.zoom = 16 // 与切换地址后的缩放级别一致

      // 处理暂存的地址
      if (this.pendingCenter) {
        this.center = this.pendingCenter
        this.pendingCenter = ''
        await this.parseAddress(BMap, map)
        return
      }

      // 初始化并更新地图位置（使用默认逻辑，可以使用坐标）
      this.updateMapLocation(false)
    },
    // 解析地址并设置标记点
    parseAddress(BMap, map) {
       return new Promise((resolve) => {
         if (!BMap || !map) {
           resolve()
           return
         }
         var myGeo = new BMap.Geocoder();
         const address = this.center;
         if (!address) {
           resolve()
           return
         }
         if (this.map) {
           this.map.clearOverlays()
         }
         // 将地址解析结果显示在地图上，并调整地图视野
         myGeo.getPoint(address, (point) => {
           if (point) {
             this.$emit('mapPoint', point)
             map.centerAndZoom(point, 16);
             map.addOverlay(new BMap.Marker(point, { title: address }))
           } else {
             if (this.$showMessage) {
               this.$showMessage("失败", "您选择的地址没有解析到结果");
             }
           }
           resolve()
         }, address)
       })
     },
    // 清除地图上所有标记和覆盖物
    clearMapMarkers(map) {
      if (!map) return
      // 清除所有覆盖物（包括标记点、信息窗口等）
      map.clearOverlays()
      // 重置地图缩放级别到默认值
      if (this.zoom) {
        map.setZoom(this.zoom)
      }
    },
  },
}
</script>

<style>
.map {
  width: 100%;
  height: 540px;
}
</style>
